import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { Grid, Select, Space } from "@masterteam/mt-design-react";

import AdminPage from "../AdminPage";
import StrategicObjectives from "./StrategicObjectives";
import KPIs from "./KPIs";

import api from "../../providers/api";
import { addToast } from "../../helpers";

import { useIsAr } from "../../Hooks";

import "./style.scss";

const { Row, Col } = Grid;

function WeightKPIs() {
  const intl = useIntl();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [selectedStrategy, setSelectedStrategy] = useState(0);
  const [selectedSO, setSelectedSO] = useState(null);
  const [selectedPillar, setSelectedPillar] = useState(0);

  const [isAr] = useIsAr();

  const getWeightData = async () => {
    setLoading(true);
    try {
      const res = await api.weight.getAll();

      setData(res.Data);
      setSelectedStrategy(0);
      setSelectedPillar(0);
    } catch (error) {
      addToast.error(error.message, { toastId: "get-users-error" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getWeightData();
  }, []);

  function getSOs() {
    if (!data?.length) return [];

    let objectives = [];

    objectives =
      data[selectedStrategy]?.Pillars?.[selectedPillar]?.Objectives ?? [];

    if (selectedSO)
      objectives = objectives?.filter((e) => e?.ID === selectedSO?.ID);

    return objectives;
  }

  function onSOSelect(soObj) {
    setSelectedSO(soObj);
  }

  function getSOTitle(e) {
    return isAr ? e?.ArabicName : e?.EnglishName;
  }

  function getSOHeaderTitle(e) {
    return isAr ? e?.ArabicName : e?.EnglishName;
  }

  function onSOUpdate(newVal) {
    setData(
      data?.map((e, i) => {
        if (i === selectedStrategy)
          return {
            ...e,
            Pillars: e?.Pillars?.map((el, j) => {
              if (j === selectedPillar) return { ...el, Objectives: newVal };

              return el;
            }),
          };

        return e;
      })
    );
  }

  const onKPIUpdate = (newVal, parentId) => {
    setData(
      data?.map((e, i) => {
        if (i === selectedStrategy)
          return {
            ...e,
            Pillars: e?.Pillars?.map((el, j) => {
              if (j === selectedPillar)
                return {
                  ...el,
                  Objectives: el?.Objectives?.map((so) =>
                    so.ID === parentId ? { ...so, KPIs: newVal } : so
                  ),
                };

              return el;
            }),
          };

        return e;
      })
    );
  };

  const getKPIEqualWeight = (length, index) => {
    const value = +(100 / length).toFixed(2);

    if (100 % length !== 0 && index === 0) {
      return value + (100 - length * value);
    } else {
      return value;
    }
  };

  const handleEqualKPIOnClick = (parentId) => {
    const _data = [...data];

    _data[selectedStrategy].Pillars[selectedPillar].Objectives = _data[
      selectedStrategy
    ]?.Pillars[selectedPillar].Objectives.map((item) => {
      if (item.ID === parentId)
        return {
          ...item,
          KPIs: item.KPIs.map((e, index) => ({
            ...e,
            Weight: getKPIEqualWeight(item.KPIs.length, index),
          })),
        };
      else return item;
    });

    setData(_data);
  };

  return (
    <AdminPage
      loading={loading}
      title={intl.formatMessage({
        id: "common.kpis-weight",
      })}
    >
      <Space>
        <div className="select-wrapper">
          <Select
            style={{ flex: 1 }}
            options={data}
            getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
            getOptionValue={(el) => el?.ID}
            onChange={(item) => {
              const index = data?.findIndex((e) => e.ID === item.ID);
              setSelectedStrategy(index);
              setSelectedPillar(0);
              setSelectedSO(null);
            }}
            value={data?.[selectedStrategy]}
          />
        </div>

        <div className="select-wrapper">
          <Select
            style={{ flex: 1 }}
            options={data?.[selectedStrategy]?.Pillars || []}
            getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
            getOptionValue={(el) => el?.ID}
            onChange={(item) => {
              const index = data?.[selectedStrategy]?.Pillars?.findIndex(
                (e) => e.ID === item.ID
              );
              setSelectedPillar(index);
              setSelectedSO(null);
            }}
            value={data?.[selectedStrategy]?.Pillars?.[selectedPillar]}
          />
        </div>
      </Space>

      <div className="weight-kpis animated fadeInLeft">
        <Row size="large">
          {/* <Col span={12}>
            <StrategicObjectives
              data={
                data?.[selectedStrategy]?.Pillars?.[selectedPillar]
                  ?.Objectives || []
              }
              title={intl.formatMessage({
                id: "common.strategic-objectives"
              })}
              onItemSelect={onSOSelect}
              selectedItem={selectedSO}
              onUpdate={onSOUpdate}
            />
          </Col> */}
          <Col span={12}>
            <KPIs
              title={intl.formatMessage({ id: "weight.by-objective" })}
              data={getSOs()}
              getHeaderTitle={getSOHeaderTitle}
              getTitle={getSOTitle}
              onUpdate={onKPIUpdate}
              apiKey="KPI"
              childrenKey="KPIs"
              handleEqualOnClick={handleEqualKPIOnClick}
            />
          </Col>
        </Row>
      </div>
    </AdminPage>
  );
}

export default WeightKPIs;
